import { useQuery, useQueryClient } from '@tanstack/react-query';
import { Link } from 'react-router-dom';
import { api } from '../api';
import { useTypes } from '../hooks';
import { t } from '../i18n';
import { classNames } from '../util';

export function useDiscoveries(cid: string, enabled = true) {
  return useQuery({ queryKey: ['discoveries', cid], queryFn: () => api.discoveries(cid), enabled, staleTime: 30_000 });
}

/** „Entdeckt“: Was der DM für den Spieler freigegeben hat, neueste zuerst. */
export function DiscoveryList({ cid, limit }: { cid: string; limit?: number }) {
  const qc = useQueryClient();
  const types = useTypes(cid);
  const q = useDiscoveries(cid);
  const items = limit ? (q.data ?? []).slice(0, limit) : (q.data ?? []);
  const unseen = (q.data ?? []).some((d) => !d.seen);
  const allSeen = async () => {
    await api.markAllSeen(cid);
    void qc.invalidateQueries({ queryKey: ['discoveries', cid] });
    void qc.invalidateQueries({ queryKey: ['notes', cid] });
  };
  return (
    <section className="card discoveries">
      <header className="row">
        <h2>{t('player.discoveries')}</h2>
        {unseen && (
          <button className="small-btn" onClick={() => void allSeen()}>
            {t('player.allSeen')}
          </button>
        )}
      </header>
      {q.data && q.data.length === 0 && <p className="muted">{t('player.nothing')}</p>}
      <ul className="recent-list">
        {items.map((d) => (
          <li key={d.id} className={classNames(!d.seen && 'is-new')}>
            <span className="type-dot" style={{ background: types.byKey.get(d.typeKey)?.color }} />
            <Link to={`/c/${cid}/n/${d.id}`}>{d.title}</Link>
            {!d.seen && <span className="new-badge">{t('player.new')}</span>}
            <span className="muted small">{new Date(d.grantedAt).toLocaleDateString('de-DE')}</span>
          </li>
        ))}
      </ul>
    </section>
  );
}
